import { useEffect, useState } from 'react';

import {
  IListCollectorUsersParams,
  listCollectorUsers,
} from '../services/identity/listCollectorUsers';
import { UserProfile } from '../services/identity/types/UserProfile';

interface IUseCollectorUsers {
  users: UserProfile[];
  dataLoading: boolean;
  totalRecords: number;
}

export default function useCollectorUsers(
  params: IListCollectorUsersParams,
): IUseCollectorUsers {
  const [users, setUsers] = useState<UserProfile[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [dataLoading, setDataLoading] = useState<boolean>(false);

  useEffect(() => {
    setDataLoading(true);
    let canceled = false;

    listCollectorUsers(params)
      .then((res) => {
        if (!canceled) {
          setTotalRecords(res.total);
          setUsers([...(res.nodes ?? [])]);
        }
      })
      .catch(() => {
        if (!canceled) {
          setTotalRecords(0);
          setUsers([]);
        }
      })
      .finally(() => {
        if (!canceled) setDataLoading(false);
      });

    return (): void => {
      canceled = true;
    };
  }, [params]);

  return {
    users,
    totalRecords,
    dataLoading,
  };
}
